import { Link } from "react-router-dom";
import { CATEGORIES } from "@/constants/data";

const CategoryShowcaseSection = () => (
  <section id="kategoriler" className="py-16 md:py-20 bg-[color:hsl(var(--secondary))] border-t border-[color:var(--line)]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-xl mx-auto mb-10">
        <span className="text-sm font-medium text-[color:var(--brand-gold-2)] uppercase tracking-wide">Portföy</span>
        <h2 className="font-[var(--font-serif)] text-2xl md:text-3xl font-semibold tracking-[-0.01em] text-[color:var(--brand-charcoal)] mt-2">
          Kategorilere Göre Keşfedin
        </h2>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {CATEGORIES.map((cat) => {
          const Icon = cat.icon;
          return (
            <Link
              key={cat.value}
              to={`/kategori/${cat.value}`}
              data-testid={`home-category-card-${cat.value}`}
              className="group rounded-[14px] border border-[color:var(--line)] bg-[color:hsl(var(--card))] p-6 flex flex-col items-center text-center gap-3 hover:shadow-[0_16px_44px_rgba(43,43,43,0.10)] hover:-translate-y-[2px] transition-[box-shadow,transform] duration-200"
            >
              <div className="h-14 w-14 rounded-full gold-gradient-surface flex items-center justify-center group-hover:scale-105 transition-transform duration-200">
                <Icon className="h-6 w-6 text-[color:var(--brand-charcoal)]" />
              </div>
              <h3 className="font-[var(--font-serif)] text-lg text-[color:var(--brand-charcoal)]">{cat.label}</h3>
              <p className="text-xs text-[color:hsl(var(--muted-foreground))] leading-relaxed">{cat.description}</p>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);

export default CategoryShowcaseSection;
